import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeSpotBidExpirationTimeOptions } from './normalize';

export const fetchSpotBidExpirationTimeOptions = createProvider(api.fetchSpotBidExpirationTimeOptions)
  .andThen((res) => normalizeSpotBidExpirationTimeOptions(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
